// Английски превод — landlord. Ключ = българският текст от кода.
export const EN_LANDLORD: Record<string, string> = {
  'Здравейте, {name}': 'Hello, {name}',
  'Здравейте': 'Hello',
  'Зареждане…': 'Loading…',
  'Имали сте наематели преди?': 'Had tenants before?',
  'Оставете отзив за миналите си наематели — минута на човек. Така следващият наемодател знае какво да очаква, а вашите кандидати се проверяват в по-пълна база.': 'Leave a review for your past tenants — a minute per person. The next landlord will know what to expect, and your applicants get checked against a fuller database.',
  'Остави отзив': 'Leave a review',
  'Нямам / по-късно': 'None / later',
  'Здравейте,': 'Hello,',
  'ОГРАНИЧЕН РЕЖИМ': 'RESTRICTED MODE',
  'Абонаментът е изтекъл — само преглед. Обявите са свалени.': 'Your subscription has expired — view only. Listings have been taken down.',
  'Поднови абонамента →': 'Renew subscription →',
  'Всичко е наред — няма нищо за одобряване.': 'All good — nothing to approve.',
  '⚠ Чака действие': '⚠ Needs action',
  'отстранени нередности чакат потвърждение': 'resolved issues awaiting confirmation',
  'плащане за потвърждение · {address}': 'payment to confirm · {address}',
  'плащания чакат „Получено“': 'payments awaiting "Received"',
  'нередности за решаване': 'issues to resolve',
  'неплатени сметки · {address}': 'unpaid bills · {address}',
  'неплатени сметки': 'unpaid bills',
  'обяви чакат одобрение от модератор': 'listings awaiting moderator approval',
  'оценете бившия наемател {name} · {address}': 'rate your former tenant {name} · {address}',
  'Бързи действия': 'Quick actions',
  'Имот': 'Property',
  'Наемател': 'Tenant',
  'Собственици': 'Owners',
  'Нередности': 'Issues',
  'Документи': 'Documents',
  'Стари наематели': 'Past tenants',
  '⭐ Имали сте наематели преди?': '⭐ Had tenants before?',
  'Оставете отзив за миналите си наематели — минута на човек, а следващият наемодател ще ви е благодарен.': 'Leave a review for your past tenants — a minute per person, and the next landlord will thank you.',
  'Скрий': 'Hide',
  'Този месец': 'This month',
  'Получено': 'Received',
  'от {amount}': 'of {amount}',
  'Просрочено': 'Overdue',
  '{n} задълж.': '{n} due',
  'няма': 'none',
  'Имоти': 'Properties',
  'Общо': 'Total',
  'Отдадени': 'Rented',
  'Свободни': 'Vacant',
  'Изтичащи договори': 'Contracts ending',
  'Имоти с дадено предизвестие — скоро се освобождават.': 'Properties with notice given — becoming vacant soon.',
  'свободен от {date}': 'vacant from {date}',
  'Неплатени': 'Unpaid',
  'Адрес': 'Address',
  'Наем': 'Rent',
  'Най-нови': 'Newest',
  'Моите имоти': 'My properties',
  'Абонаментът е изтекъл — само преглед. Обявите са свалени, наемателите ви не могат да плащат през приложението.': 'Your subscription has expired — view only. Listings have been taken down and your tenants cannot pay through the app.',
  '+ Нов имот': '+ New property',
  'Търси по адрес, наемател или телефон…': 'Search by address, tenant or phone…',
  'Няма намерен имот по това търсене.': 'No property matches this search.',
  'Още нямате добавени имоти.': 'You have no properties yet.',
  '👤 Собственик — добави / смени': '👤 Owner — add / change',
  '👥 Обитатели': '👥 Residents',
  '🗄️ Архивирай имота': '🗄️ Archive property',
  'Имот с наемател не може да се архивира — първо приключете наемното отношение.': 'A property with a tenant cannot be archived — end the tenancy first.',
  'Архивиране': 'Archive',
  'Наистина ли архивирате {address}? Историята се запазва; връщане — от Още → „Архивирани имоти“.': 'Archive {address}? History is kept; restore it from More → "Archived properties".',
  'Архивирай': 'Archive',
  'Имотът е в архива.': 'The property has been archived.',
  '{n} стаи': '{n} rooms',
  'ет. {n}': 'floor {n}',
  'Просрочено: {amount}': 'Overdue: {amount}',
  'Най-старо просрочие от {date}': 'Oldest overdue since {date}',
  'Чака потвърждение: {n}': 'Awaiting confirmation: {n}',
  'Отдаден': 'Rented',
  'Чака регистрация': 'Awaiting sign-up',
  '{amount}/мес.': '{amount}/mo.',
  'Свободен': 'Vacant',
  'Статистика': 'Statistics',
  'Събран наем (общо)': 'Rent collected (total)',
  'Последните 12 месеца': 'Last 12 months',
  'Заетост (последните 12 месеца)': 'Occupancy (last 12 months)',
  '{n} от 12 месеца имотът е бил отдаден': 'Rented for {n} of the last 12 months',
  'Депозит': 'Deposit',
  'Взет депозит': 'Deposit taken',
  'Настоящ наемател': 'Current tenant',
  'Наемател от 1 месец': 'Tenant for 1 month',
  'Наемател от {n} месеца': 'Tenant for {n} months',
  'от {date}': 'since {date}',
  'Месечен наем: {amount}': 'Monthly rent: {amount}',
  'В момента няма наемател.': 'No tenant at the moment.',
  'Щети и ремонти': 'Damage and repairs',
  '({resolved}/{total} отстранени)': '({resolved}/{total} resolved)',
  'Няма регистрирани щети или ремонти за този имот. 👍': 'No damage or repairs recorded for this property. 👍',
  'Общо платено за ремонти': 'Total paid for repairs',
  'Отстранено ✓': 'Resolved ✓',
  'В процес': 'In progress',
  'ремонт за {amount}': 'repair for {amount}',
  'без платен ремонт': 'no paid repair',
  'Абонаментът ви е платен до {date}. С добавянето на имота автоматично ще се изтеглят около {amount} от картата ви — пропорционално за оставащите дни. След това имотът влиза в месечната сума.': 'Your subscription is paid until {date}. Adding this property will automatically charge about {amount} to your card — pro rata for the remaining days. After that the property is included in the monthly amount.',
  'Имотът е добавен. Изтеглени са {amount} за оставащите дни от периода.': 'Property added. {amount} was charged for the remaining days of the period.',
  'Лимит на плана': 'Plan limit',
  'Смени плана': 'Change plan',
  'По-късно': 'Later',
  'Нов имот': 'New property',
  'ул. Витоша 15, ап. 7': '15 Vitosha St, apt. 7',
  'Населено място': 'Town / village',
  'Квартал / район': 'Neighbourhood / district',
  'Изберете квартал': 'Select a neighbourhood',
  'Име на квартала': 'Neighbourhood name',
  'По квартала известяваме търсещи наематели, когато имотът се освободи.': 'We notify tenants searching in this neighbourhood when the property becomes vacant.',
  'Квартал / район (по избор)': 'Neighbourhood / district (optional)',
  'Площ (кв.м)': 'Area (sq m)',
  'Етаж': 'Floor',
  'Стаи': 'Rooms',
  'Описание': 'Description',
  'Светъл двустаен…': 'Bright one-bedroom…',
  'Снимки ({n})': 'Photos ({n})',
  '+ Добави снимка': '+ Add photo',
  'Снимките се качват веднага в хранилището.': 'Photos are uploaded to storage immediately.',
  'Собственик — телефон (кани се по SMS)': 'Owner — phone (invited by SMS)',
  'Собственик — име и фамилия': 'Owner — first and last name',
  'Стоян': 'John',
  'Стоянов': 'Smith',
  'Процент за управление (празно = по подразбиране)': 'Management fee % (blank = default)',
  'Запази имота': 'Save property',
  'Наемателят е добавен. Бележка за депозита е издадена в „Документи“.': 'Tenant added. A deposit receipt has been issued in "Documents".',
  'Наемателят е добавен. Той ще може да се регистрира с този номер.': 'Tenant added. They will be able to sign up with this number.',
  'Добавяне на наемател': 'Add tenant',
  'Въвеждането на номера отключва регистрацията на наемателя. Той ще получи SMS с покана.': 'Entering the number unlocks the tenant\'s sign-up. They will receive an SMS invitation.',
  'Телефон на наемателя': 'Tenant\'s phone',
  'Провери историята му 🔎': 'Check their history 🔎',
  '✓ Проверено — чист номер': '✓ Checked — clean number',
  'Няма регистриран наемател, история или ревюта за този номер. След добавянето му кажете на наемателя да свали Livupp и да влезе от „Първи вход" с този номер — кодът идва по SMS.': 'No registered tenant, history or reviews for this number. After adding them, tell the tenant to download Livupp and use "First login" with this number — the code arrives by SMS.',
  'без ревюта': 'no reviews',
  '{n} мес.': '{n} mo.',
  '(текуща квартира!)': '(current home!)',
  'Внимание: има активно наемно отношение': 'Warning: has an active tenancy',
  'Месечен наем (€)': 'Monthly rent (€)',
  'Падежен ден от месеца': 'Due day of the month',
  'Наемът се плаща от – до число (за договора)': 'Rent is paid from – to day of month (for the contract)',
  'Влиза в Член 7 на договора: „наем от 1-то до 5-то число“.': 'Goes into Article 7 of the contract: "rent from the 1st to the 5th".',
  'Начало на договора': 'Contract start',
  'дд.мм.гггг': 'dd.mm.yyyy',
  'Срок (месеци)': 'Term (months)',
  'Оставете празно за безсрочен договор.': 'Leave blank for an open-ended contract.',
  'Наем за първия непълен период': 'Rent for the first partial period',
  'Начисли наем за непълния период': 'Charge rent for the partial period',
  'Сума (€)': 'Amount (€)',
  'Изчислено: {rate} €/ден × {days} дни. Може да въведете и друга сума по ваша уговорка.': 'Calculated: {rate} €/day × {days} days. You may enter a different amount as agreed.',
  'Депозит (€, по избор)': 'Deposit (€, optional)',
  'Как ще се преведе депозитът?': 'How will the deposit be paid?',
  'По банка': 'Bank transfer',
  'В брой': 'Cash',
  'Депозитът вече е получен в брой': 'Deposit already received in cash',
  'Ще се издаде бележка (разписка) за депозита в „Документи“.': 'A deposit receipt will be issued in "Documents".',
  'Депозитът става задължение на наемателя с отделен код за основание — плаща се като наема и може да приложи снимка на платежното.': 'The deposit becomes a tenant obligation with its own reference code — paid like rent, and they can attach a photo of the transfer slip.',
  'Добави наемател': 'Add tenant',
  'Нова сметка': 'New bill',
  'Вид': 'Type',
  'Месец': 'Month',
  'Година': 'Year',
  'Снимка на фактурата': 'Invoice photo',
  'Смени снимката': 'Change photo',
  '+ Снимка на фактурата': '+ Invoice photo',
  'Наемателят получава известие веднага след запазване.': 'The tenant is notified as soon as you save.',
  'Запази сметката': 'Save bill',
  'ИТН / клиентски номер': 'Meter / customer number',
  'Номерата са видими за наемателя, когато той плаща сметките сам.': 'The numbers are visible to the tenant when they pay the bills themselves.',
  'Услуга': 'Service',
  'Доставчик (по избор)': 'Provider (optional)',
  'Електрохолд': 'Electrohold',
  'Запази': 'Save',
  'Автоматично теглене': 'Direct debit',
  'Напомнихме на наемателя.': 'Reminder sent to the tenant.',
  'Готово: {title}': 'Done: {title}',
  'Имотът се освободи': 'Property is now vacant',
  'Трябва ли ви почистване или ремонт преди следващия наемател? Ще поискаме оферти от майсторите в областта.': 'Need cleaning or repairs before the next tenant? We will request quotes from handymen in the region.',
  'Поискай оферти': 'Request quotes',
  'Освежаване след изнасяне': 'Refresh after move-out',
  'Наемателят се изнесе — търсим оферти за почистване/освежаване преди следващото настаняване.': 'The tenant moved out — looking for quotes for cleaning/refreshing before the next move-in.',
  'Приключване': 'End tenancy',
  'Наистина ли приключвате наемното отношение?': 'Are you sure you want to end the tenancy?',
  'Приключи': 'End',
  'Оценете бившия наемател': 'Rate your former tenant',
  '{name} вече не е ваш наемател. Оставете отзив — той помага на следващия наемодател при проверката по телефон. Ако пропуснете сега, напомняне ще чака на началния екран.': '{name} is no longer your tenant. Leave a review — it helps the next landlord when checking by phone. If you skip now, a reminder will wait on the home screen.',
  'Оцени наемателя ★': 'Rate tenant ★',
  '{n} кв.м': '{n} sq m',
  '📊 Статистика на имота': '📊 Property statistics',
  'Пари': 'Money',
  'Собственик (поканен)': 'Owner (invited)',
  'Име': 'Name',
  'Телефон': 'Phone',
  'Изпратен е SMS с покана. Договорът за управление се създава при първия му вход.': 'An SMS invitation has been sent. The management contract is created on their first login.',
  'Договор за управление': 'Management contract',
  'Собственик': 'Owner',
  'Процент за управление': 'Management fee %',
  'При прекратяване имотът се замразява, докато собственикът не реши да го поеме сам или да го даде на друг пропърти мениджър.': 'On termination the property is frozen until the owner decides to manage it themselves or hand it to another property manager.',
  'Прекрати управлението': 'Terminate management',
  'Прекратяване на управлението': 'Terminate management',
  'Наистина ли прекратявате управлението на {address}? Имотът ще се замрази.': 'Terminate management of {address}? The property will be frozen.',
  'Прекрати': 'Terminate',
  'Управлението е прекратено. Имотът е замразен.': 'Management terminated. The property is frozen.',
  'Получаване на наема': 'Rent collection',
  'Начин': 'Method',
  'Промени начина': 'Change method',
  '{phone} (чака регистрация)': '{phone} (awaiting sign-up)',
  '📞 Позвъни на наемателя': '📞 Call the tenant',
  'Падеж': 'Due',
  '{day}-о число': 'day {day}',
  'Код за превод': 'Transfer code',
  'получен {date}': 'received {date}',
  'по банка — чака плащане': 'bank transfer — awaiting payment',
  'в брой — чака': 'cash — pending',
  'Договор': 'Contract',
  'безсрочен': 'open-ended',
  'Протокол': 'Handover',
  'Няма наемател.': 'No tenant.',
  '+ Добави наемател по телефон': '+ Add tenant by phone',
  'Публикувай обява 🔎': 'Publish listing 🔎',
  '✓ Обявата е публикувана — вижте я в „Свободни апартаменти" → Моите обяви.': '✓ Listing published — see it in "Vacant apartments" → My listings.',
  'Обявата чака одобрение от модератор.': 'The listing is awaiting moderator approval.',
  'Обявата е отхвърлена: {reason}': 'Listing rejected: {reason}',
  'Публикувай пак обява': 'Publish listing again',
  'Обявата е изпратена за одобрение.': 'Listing submitted for approval.',
  'Редактирай обява': 'Edit listing',
  'Ремонт / поддръжка': 'Repairs / maintenance',
  'Заявете ремонт за имота. Освобождаването на плащането се потвърждава от вас и наемателя.': 'Request a repair for the property. Payment release is confirmed by you and the tenant.',
  'Няма наемател — ремонтът се потвърждава само от вас.': 'No tenant — the repair is confirmed by you only.',
  '🛠️ Заяви ремонт': '🛠️ Request repair',
  'Минали наематели': 'Past tenants',
  'до {date}': 'until {date}',
  'Наеми': 'Rent payments',
  'Частичен наем · {month}': 'Partial rent · {month}',
  'Такса за превода −{fee}': 'Transfer fee −{fee}',
  'пропърти мениджър {agency} · собственик {owner}': 'property manager {agency} · owner {owner}',
  'Кодът {code} е вписан ✓': 'Code {code} is on the slip ✓',
  'Кодът НЕ се открива в платежното — проверете внимателно': 'Code NOT found on the slip — check carefully',
  'Платежното не беше разчетено — проверете сметката си.': 'The slip could not be read — check your account.',
  'Без приложено платежно — проверете сметката си за кода.': 'No slip attached — check your account for the code.',
  '⚠️ В платежното: {slip} · дължимо: {due} (разлика {diff})': '⚠️ On the slip: {slip} · due: {due} (difference {diff})',
  'Снимката е нареждане, не гаранция — потвърдете чак след като видите парите.': 'The photo is an order, not a guarantee — confirm only once you see the money.',
  'Получено ✓': 'Received ✓',
  'Получено по банка ✓': 'Received by bank ✓',
  'Получих в брой': 'Received in cash',
  '🔔 Напомни на наемателя': '🔔 Remind the tenant',
  'Потвърди: получих в брой ✓': 'Confirm: received in cash ✓',
  'Чака потвърждение от наемателя.': 'Awaiting confirmation from the tenant.',
  'Документи (PDF)': 'Documents (PDF)',
  'Генерират се с данните на двете страни и влизат в архива.': 'Generated with both parties\' details and stored in the archive.',
  'Фактура': 'Invoice',
  'Разписка депозит': 'Deposit receipt',
  'Предизвестие': 'Notice',
  'Добавете наемател, за да генерирате договор и документи. Старите документи на имота остават тук.': 'Add a tenant to generate a contract and documents. The property\'s older documents stay here.',
  'Документи на имота ({n})': 'Property documents ({n})',
  'Още няма генерирани документи за този имот.': 'No documents generated for this property yet.',
  'Отвори (PDF)': 'Open (PDF)',
  'Всички документи →': 'All documents →',
  'Приемо-предавателни протоколи': 'Handover protocols',
  'При настаняване': 'Move-in',
  'При напускане': 'Move-out',
  '{n} снимки': '{n} photos',
  'Потвърден от наемателя ✓': 'Confirmed by tenant ✓',
  'Чака потвърждение': 'Awaiting confirmation',
  'Забележка от наемателя: „{remark}“': 'Tenant\'s remark: "{remark}"',
  'Приета — част от протокола ✓': 'Accepted — part of the protocol ✓',
  'Приемам забележката': 'Accept the remark',
  'Сметки': 'Bills',
  'Няма добавени сметки.': 'No bills added.',
  'Платена': 'Paid',
  'Неплатена': 'Unpaid',
  '+ Нова сметка': '+ New bill',
  'ИТН / клиентски номера': 'Meter / customer numbers',
  'Няма въведени номера.': 'No numbers entered.',
  '+ Добави номер': '+ Add number',
  'Архив': 'Archive',
  'За продаден имот или прекратена работа с него. Историята (плащания, документи, протоколи) се запазва — имотът отива в Още → „Архивирани имоти“ и може да се върне оттам.': 'For a sold property or one you no longer manage. History (payments, documents, protocols) is kept — the property goes to More → "Archived properties" and can be restored from there.',
  'Първо приключете наемното отношение.': 'End the tenancy first.',
  'Архивирай имота': 'Archive property',
  'Наистина ли архивирате {address}? Обявата му се сваля, а при пропърти мениджър договорът за управление се прекратява.': 'Archive {address}? Its listing is taken down and, for a property manager, the management contract is terminated.',
  'Наемателят получи известие да потвърди състоянието.': 'The tenant has been notified to confirm the condition.',
  'Приемо-предавателен протокол': 'Handover protocol',
  'Данни на страните и имота': 'Parties and property details',
  'Зареждам данните от договора…': 'Loading details from the contract…',
  '✓ Копирани от договора — влизат в протокола': '✓ Copied from the contract — included in the protocol',
  'Наемодател: {name}': 'Landlord: {name}',
  'Наемател: {name}': 'Tenant: {name}',
  'Втори наемател: {name}': 'Second tenant: {name}',
  'ЕГН, лична карта и адресите също влизат в протокола.': 'Personal ID number, ID card and addresses are also included in the protocol.',
  'Не включвай данните': 'Do not include the details',
  'Пренася имената, ЕГН, личната карта и адресите на двете страни и описанието на имота — точно както са в договора.': 'Copies the names, personal ID numbers, ID cards and addresses of both parties and the property description — exactly as in the contract.',
  'Копирай данните от договора': 'Copy details from the contract',
  'Снимки на състоянието ({n})': 'Condition photos ({n})',
  'Забележки': 'Notes',
  'Без забележки': 'No remarks',
  'Наемателят ще потвърди в приложението, че приема имота в това състояние (с точен час на потвърждението).': 'The tenant will confirm in the app that they accept the property in this condition (with the exact time of confirmation).',
  'Изпрати за потвърждение': 'Send for confirmation',
  'По банка (IBAN)': 'Bank transfer (IBAN)',
  'Наемателят превежда сам с уникален код за основание. Нула такси.': 'The tenant transfers with a unique reference code. Zero fees.',
  'Двустранно потвърждение в приложението + автоматична бележка.': 'Two-way confirmation in the app + automatic receipt.',
  'Автоматично теглене (SEPA)': 'Direct debit (SEPA)',
  'Наемът се тегли сам всеки месец от сметката на наемателя.': 'Rent is debited automatically every month from the tenant\'s account.',
  'Начинът на получаване е обновен.': 'Collection method updated.',
  'Изборът важи само за този имот — за друг имот може да е различен.': 'This choice applies to this property only — another property may differ.',
  'СКОРО': 'SOON',
  'Потвърди избора': 'Confirm choice',
  'Имотът е добавен към собственика.': 'Property added to the owner.',
  'Имотът е премахнат от собственика.': 'Property removed from the owner.',
  'Всички собственици, чиито имоти управлявате — с телефон и имотите на всеки. Нов собственик се добавя при създаване на имот или от бутона „Добави имот“ по-долу.': 'All owners whose properties you manage — with phone and each one\'s properties. A new owner is added when creating a property or via the "Add property" button below.',
  'Още няма собственици': 'No owners yet',
  'Добавете имот и посочете собственика му по телефон — той ще получи SMS с покана.': 'Add a property and specify its owner by phone — they will receive an SMS invitation.',
  'Без име': 'No name',
  'регистриран': 'registered',
  'поканен': 'invited',
  '{n}% за управление': '{n}% management fee',
  'Потвърди ✕': 'Confirm ✕',
  'Премахни': 'Remove',
  'Няма имоти — поканата чака регистрация.': 'No properties — the invitation is awaiting sign-up.',
  'Изберете свободен имот…': 'Select an unassigned property…',
  'Няма свободни имоти — всички вече имат собственик.': 'No unassigned properties — all already have an owner.',
  'Добави имот': 'Add property',
  'Връщане от архива': 'Restore from archive',
  '{address}, {city} става активен имот отново.': '{address}, {city} becomes an active property again.',
  'Върни': 'Restore',
  'Имотът е върнат от архива.': 'Property restored from the archive.',
  'Архивирани имоти': 'Archived properties',
  'Историята им (плащания, документи, протоколи) е запазена. Не се броят в лимита на плана.': 'Their history (payments, documents, protocols) is kept. They do not count towards the plan limit.',
  'Архивът е празен': 'The archive is empty',
  'Имот се архивира от екрана му: Още → „Архивирай имота“.': 'A property is archived from its screen: More → "Archive property".',
  'архивиран на {date}': 'archived on {date}',
  'собственик {name}': 'owner {name}',
  'Върни от архива': 'Restore from archive',
  'Собственикът е закачен — той е регистриран и получи известие.': 'Owner assigned — they are registered and have been notified.',
  'Изпратихме SMS с код за вход (важи 24 часа).': 'We sent an SMS with a login code (valid 24 hours).',
  'Поканата е записана, но SMS-ът не тръгна — проверете номера.': 'The invitation was saved but the SMS was not sent — check the number.',
  'Текущ собственик': 'Current owner',
  'Процент': 'Percent',
  'Поканен собственик': 'Invited owner',
  'чака първия си вход': 'awaiting first login',
  'Смяна на собственика': 'Change owner',
  'Добавяне на собственик': 'Add owner',
  'Старият договор за управление се прекратява, а старият собственик получава известие.': 'The old management contract is terminated and the previous owner is notified.',
  'Иван': 'John',
  'Фамилия': 'Last name',
  'Иванов': 'Smith',
  'Процент за управление (по избор)': 'Management fee % (optional)',
  'по подразбиране от профила': 'default from your profile',
  'Ако собственикът няма акаунт, получава ЕДИН SMS с код за вход, валиден 24 часа. Регистрираният получава само известие в приложението.': 'If the owner has no account, they receive ONE SMS with a login code valid for 24 hours. A registered owner only gets an in-app notification.',
  'Смени собственика': 'Change owner',
  'Добави собственик': 'Add owner',
  'Отзивът е записан. Може да добавите още един.': 'Review saved. You can add another one.',
  'Имали сте наематели преди Livupp? Оставете отзив за тях — така следващият наемодател ще знае какво да очаква, а вашите бъдещи кандидати ще се проверяват в по-пълна база. Отнема минута на човек.': 'Had tenants before Livupp? Leave a review for them — the next landlord will know what to expect, and your future applicants get checked against a fuller database. It takes a minute per person.',
  'Добавени сега': 'Just added',
  'Оценка': 'Rating',
  'Коментар (по избор)': 'Comment (optional)',
  'Плащаше навреме, върна имота в добро състояние…': 'Paid on time, returned the property in good condition…',
  'Отзивът е ваше лично твърдение за собствен опит и се вижда при проверка на този номер. Пишете само истината — неверни отзиви се премахват при проверка.': 'The review is your personal statement about your own experience and is shown when this number is checked. Write only the truth — false reviews are removed upon verification.',
  'Запази отзива': 'Save review',
  'Готово': 'Done',
  'Запитването е изпратено до {n} майстори „{specialty}“ в областта. Ще получите офертите им.': 'Request sent to {n} "{specialty}" handymen in the region. You will receive their quotes.',
  'Запитването е изпратено до {n} майстор(и).': 'Request sent to {n} handyman/men.',
  'Избор на майстор': 'Choose a handyman',
  'Най-бързият начин': 'The fastest way',
  'Избери каква работа е нужна и прати запитването до всички такива майстори в областта на имота — те се състезават с оферти, ти избираш най-добрата.': 'Pick the kind of work needed and send the request to all such handymen in the property\'s region — they compete with quotes, you choose the best one.',
  'Каква работа е нужна?': 'What work is needed?',
  '📣 Първо избери категория': '📣 Pick a category first',
  '📣 До всички „{specialty}“ в областта': '📣 To all "{specialty}" in the region',
  'Или избери ръчно': 'Or pick manually',
  'Област': 'Region',
  'Специалност': 'Specialty',
  'Няма регистрирани майстори за тази област.': 'No registered handymen for this region.',
  'Съобщение (по избор)': 'Message (optional)',
  'Кога можете да минете?': 'When can you come by?',
  'Изпрати запитване ({n})': 'Send request ({n})',
  'Офертата е приета — майсторът е уведомен. Плащате му директно след двойното потвърждение.': 'Quote accepted — the handyman has been notified. You pay them directly after the two-way confirmation.',
  'Възлагане на ремонта': 'Assign the repair',
  'Майстор': 'Handyman',
  'Работа': 'Job',
  'Договорена сума': 'Agreed amount',
  'Как работи: майсторът извършва ремонта и качва снимка; след като и вие (и наемателят, ако има) потвърдите готовата работа, плащате му {amount} директно — по банка или в брой. При несъгласие се отваря спор към модератор.': 'How it works: the handyman does the repair and uploads a photo; once you (and the tenant, if any) confirm the finished work, you pay them {amount} directly — by bank or in cash. In case of disagreement a dispute is opened with a moderator.',
  'Възложи за {amount}': 'Assign for {amount}',
  'Обявата е изпратена за одобрение от модератор.': 'Listing submitted for moderator approval.',
  'Редакция на обява': 'Edit listing',
  'Нова обява': 'New listing',
  'Промените минават през ново одобрение от модератор, но обявата и чатовете ѝ се запазват.': 'Changes go through moderator approval again, but the listing and its chats are kept.',
  'Градът се взима от имота. Обявата се преглежда от модератор преди публикуване.': 'The city is taken from the property. The listing is reviewed by a moderator before publishing.',
  'Заглавие': 'Title',
  'Светъл двустаен до метрото': 'Bright one-bedroom near the metro',
  'Обзаведен, южно изложение, до парка…': 'Furnished, south-facing, next to the park…',
  '📸 Обявите със снимки получават повече запитвания — добавете поне една.': '📸 Listings with photos get more enquiries — add at least one.',
  'Снимките се показват в обявата и на картата в началния екран.': 'Photos are shown in the listing and on the home screen card.',
  'Запази и изпрати за одобрение': 'Save and submit for approval',
  'Изпрати за одобрение': 'Submit for approval',
  'Абонаментът е активен! Всичко е възстановено.': 'Subscription active! Everything is restored.',
  'Не открихме активен абонамент за този Apple ID.': 'No active subscription found for this Apple ID.',
  'Абонаментът е възстановен.': 'Subscription restored.',
  'Не успяхме да отворим настройките на Apple ID.': 'Could not open Apple ID settings.',
  'Картата {brand} •••• {last4} е запазена.': 'Card {brand} •••• {last4} saved.',
  'Картата е премахната.': 'Card removed.',
  'Прекратяване на плана': 'Cancel plan',
  'Платили сте до {date} — остава още 1 ден пълен достъп. Нищо повече няма да се тегли, а след тази дата акаунтът минава в режим само за четене. Може да се върнете по всяко време.': 'You are paid until {date} — 1 more day of full access. Nothing more will be charged, and after that date the account switches to read-only mode. You can come back at any time.',
  'Платили сте до {date} — остават още {n} дни пълен достъп. Нищо повече няма да се тегли, а след тази дата акаунтът минава в режим само за четене. Може да се върнете по всяко време.': 'You are paid until {date} — {n} more days of full access. Nothing more will be charged, and after that date the account switches to read-only mode. You can come back at any time.',
  'Абонаментът ще бъде прекратен. Може да се върнете по всяко време.': 'The subscription will be cancelled. You can come back at any time.',
  'Прекрати след изтичането': 'Cancel at period end',
  'Планът е прекратен. Достъпът остава до {date} (още 1 ден).': 'Plan cancelled. Access remains until {date} (1 more day).',
  'Планът е прекратен. Достъпът остава до {date} (още {n} дни).': 'Plan cancelled. Access remains until {date} ({n} more days).',
  'Планът е прекратен.': 'Plan cancelled.',
  'Абонамент': 'Subscription',
  'Активен достъп': 'Active access',
  'ОГРАНИЧЕН РЕЖИМ (само четене)': 'RESTRICTED MODE (read-only)',
  'До: {date}': 'Until: {date}',
  'Текущ план': 'Current plan',
  'Месечна цена': 'Monthly price',
  'Безплатно 🎉': 'Free 🎉',
  '{amount} (индивидуална)': '{amount} (custom)',
  'Цена': 'Price',
  '{amount} на апартамент/месец': '{amount} per apartment/month',
  'Ваши имоти': 'Your properties',
  '{n} бр.': '{n}',
  'Общо: {amount}': 'Total: {amount}',
  'безплатно': 'free',
  '{amount}/месец': '{amount}/month',
  '{amount} × {n} имота. Добавите ли имот, сумата се преизчислява.': '{amount} × {n} properties. If you add a property, the amount is recalculated.',
  'Автоматичното подновяване е включено — абонаментът ще се подновява сам.': 'Auto-renewal is on — the subscription will renew automatically.',
  'Автоматичните плащания са спрени. Достъпът остава до края на платения период.': 'Automatic payments are stopped. Access remains until the end of the paid period.',
  'Автоматично подновяване (плащане всеки месец)': 'Auto-renewal (monthly payment)',
  'Автоматичните плащания са спрени: след {date} акаунтът минава в режим само за четене.': 'Automatic payments are stopped: after {date} the account switches to read-only mode.',
  'края на периода': 'the end of the period',
  'Прекрати плана': 'Cancel plan',
  'Абонаментът е през App Store. Подновяването и прекратяването се управляват от Apple ID.': 'The subscription is via the App Store. Renewal and cancellation are managed from your Apple ID.',
  'Управление на абонамента': 'Manage subscription',
  'Планът е прекратен. Пълният достъп остава до {date} (още {n} дни) — нищо повече няма да се тегли.': 'Plan cancelled. Full access remains until {date} ({n} more days) — nothing more will be charged.',
  'Възобнови плана (без ново плащане)': 'Resume plan (no new payment)',
  'В ограничен режим не може да добавяте или променяте нищо, обявите ви са свалени, а наемателите ви не могат да плащат през приложението. Изберете план — всичко се възстановява веднага.': 'In restricted mode you cannot add or change anything, your listings are taken down, and your tenants cannot pay through the app. Choose a plan — everything is restored immediately.',
  'Първо добавете имот': 'Add a property first',
  'Абонаментът се появява тук, след като въведете първия си имот — тогава започва и безплатният пробен период. Дотогава не дължите нищо.': 'The subscription appears here once you add your first property — that is when the free trial starts. Until then you owe nothing.',
  'Абонаментът, плановете и картата за плащане се появяват тук, след като въведете първия си имот — тогава започва и безплатният пробен период. Дотогава не дължите нищо.': 'The subscription, plans and payment card appear here once you add your first property — that is when the free trial starts. Until then you owe nothing.',
  'Карта за плащане': 'Payment card',
  'Запазена карта': 'Saved card',
  'Месечният абонамент се тегли автоматично от тази карта.': 'The monthly subscription is charged automatically to this card.',
  'Смени картата': 'Change card',
  'Добавете карта, за да активирате абонамент. Данните ѝ се въвеждат на сигурната страница на Stripe — ние не ги виждаме и не ги съхраняваме.': 'Add a card to activate a subscription. Its details are entered on Stripe\'s secure page — we never see or store them.',
  'Добави карта': 'Add card',
  'Абонаментът за наемодатели се управлява извън мобилното приложение. Тук виждате състоянието на достъпа си.': 'The landlord subscription is managed outside the mobile app. Here you can see your access status.',
  'Над {n} имота': 'More than {n} properties',
  'Плановете за повече от {n} имота се уреждат извън приложението.': 'Plans for more than {n} properties are arranged outside the app.',
  'Абонамент за 1 имот': 'Subscription for 1 property',
  'Абонамент за {n} имота': 'Subscription for {n} properties',
  '/месец': '/month',
  'Зареждане на цената от App Store…': 'Loading the price from the App Store…',
  'Планът не е наличен в App Store в момента. Опитайте отново по-късно.': 'The plan is not available in the App Store right now. Try again later.',
  'Автоматично подновяващ се месечен абонамент. Може да го спрете по всяко време от настройките на Apple ID.': 'Auto-renewing monthly subscription. You can stop it at any time from your Apple ID settings.',
  'С абонирането приемате': 'By subscribing you accept',
  'Абонирай се': 'Subscribe',
  'Планът е по-малък от имотите ви': 'Your plan is smaller than your properties',
  'Имате {n} имота, а планът ви покрива {limit}. Сменете плана, за да добавяте имоти.': 'You have {n} properties but your plan covers {limit}. Change the plan to add properties.',
  'Нов план: {price}/месец за {n} имота. Автоматично подновяващ се месечен абонамент; разликата се преизчислява от Apple.': 'New plan: {price}/month for {n} properties. Auto-renewing monthly subscription; Apple prorates the difference.',
  'Със смяната приемате': 'By changing you accept',
  'Възстанови покупките': 'Restore purchases',
  'Промо код (по избор)': 'Promo code (optional)',
  '✓ Кодът е приет — {discount}. Цените долу са преизчислени.': '✓ Code accepted — {discount}. Prices below are recalculated.',
  '−{n}% за първия месец': '−{n}% for the first month',
  '−{amount} за първия месец': '−{amount} for the first month',
  'Този код не е валиден или е изтекъл.': 'This code is invalid or has expired.',
  'Ако имате код за отстъпка — въведете го тук и после изберете план. Прилага се веднага.': 'If you have a discount code, enter it here and then choose a plan. It applies immediately.',
  'Планове': 'Plans',
  'Още няма конфигурирани планове.': 'No plans configured yet.',
  'на апартамент/мес.': 'per apartment/mo.',
  'При вашите {n} имота:': 'For your {n} properties:',
  'за първия месец, после {amount}/месец': 'for the first month, then {amount}/month',
  'При вашите {n} имота: {amount}/месец': 'For your {n} properties: {amount}/month',
  'До {n} апартамента': 'Up to {n} apartments',
  'Без лимит на апартаментите': 'No limit on apartments',
  '✓ Текущ план — платен до {date}': '✓ Current plan — paid until {date}',
  'Избери този план': 'Choose this plan',
  'Невалидна дата. Използвайте формат дд.мм.гггг.': 'Invalid date. Use the format dd.mm.yyyy.',
  'Фактура № {old} е анулирана; издадена е нова № {next}.': 'Invoice No. {old} was cancelled; new No. {next} issued.',
  'Фактура № {number} е издадена.': 'Invoice No. {number} issued.',
  'Редакция на фактура': 'Edit invoice',
  'Нова фактура': 'New invoice',
  'По чл. 114 ЗДДС издадена фактура не се променя: № {number} ще бъде АНУЛИРАНА, а на нейно място ще се издаде нова със следващ номер и същите (или поправени) редове.': 'Under Art. 114 of the VAT Act an issued invoice cannot be changed: No. {number} will be CANCELLED and a new one with the next number and the same (or corrected) lines will be issued instead.',
  'Получател: {name}': 'Recipient: {name}',
  'Бърз избор от задълженията': 'Quick pick from dues',
  'Редове на фактурата': 'Invoice lines',
  'Няма добавени редове. Изберете от задълженията горе или добавете ръчно.': 'No lines added. Pick from the dues above or add manually.',
  'Наименование': 'Description',
  'Напр. Наем месец юли': 'E.g. Rent for July',
  'Количество': 'Quantity',
  'Ед. цена (€)': 'Unit price (€)',
  'Премахни реда': 'Remove line',
  '+ Добави ред ръчно': '+ Add line manually',
  'Номер на фактурата (по избор)': 'Invoice number (optional)',
  'автоматичен': 'automatic',
  'Остави празно за автоматичен пореден номер. Ръчен номер продължава поредицата оттам.': 'Leave blank for an automatic sequential number. A manual number continues the sequence from there.',
  'Дата на издаване': 'Issue date',
  'Начин на плащане': 'Payment method',
  'Общо (данъчна основа)': 'Total (taxable base)',
  'ДДС се начислява според настройката ви (Профил → Данни за фактури).': 'VAT is applied according to your setting (Profile → Invoice details).',
  'Издай фактура ({amount})': 'Issue invoice ({amount})',
  'Общи': 'General',
  'Дата на договора': 'Contract date',
  'Град на сключване': 'City of signing',
  'Наемодател': 'Landlord',
  'Име, презиме и фамилия (или фирма)': 'Full name (or company)',
  'ЕГН / ЕИК': 'Personal ID No. / Company ID',
  'Лична карта №': 'ID card No.',
  'Издадена на': 'Issued on',
  'От РПУ на МВР — град': 'Issued by (police dept.) — city',
  'напр. Пловдив': 'e.g. Plovdiv',
  'Име, презиме и фамилия': 'Full name',
  'ЕГН': 'Personal ID No.',
  'напр. София': 'e.g. Sofia',
  'Адрес по лична карта': 'Address per ID card',
  'Втори наемател (по избор)': 'Second tenant (optional)',
  'Имот и условия': 'Property and terms',
  'Имотът (вид, площ, етаж)': 'Property (type, area, floor)',
  'Имотът (адрес)': 'Property (address)',
  'Ще се използва за (Член 2)': 'To be used for (Article 2)',
  'Ползватели на имота (Член 4)': 'Occupants of the property (Article 4)',
  'Месечен наем (Член 5)': 'Monthly rent (Article 5)',
  'Наемът с думи': 'Rent in words',
  'Плаща се от число (Член 7)': 'Paid from day (Article 7)',
  'до число (Член 7)': 'to day (Article 7)',
  'Депозит (Член 18)': 'Deposit (Article 18)',
  'Депозитът с думи': 'Deposit in words',
  'Срок в месеци (Член 22)': 'Term in months (Article 22)',
  'Считано от (Член 22)': 'Starting from (Article 22)',
  'Договор за наем': 'Rental contract',
  'По образеца, с данните от приложението. Непопълнените полета просто отпадат от готовия договор.': 'Based on the template, with data from the app. Blank fields are simply left out of the final contract.',
  'Липсват данни': 'Missing data',
  'Наемателят ги допълва от Профил, или ги въведете ръчно долу.': 'The tenant fills them in from Profile, or enter them manually below.',
  'Ще останат празни в договора': 'Will remain blank in the contract',
  '+ Добави втори наемател (по избор)': '+ Add second tenant (optional)',
  'Попълва се само при двама наематели — иначе блокът липсва от договора.': 'Fill in only for two tenants — otherwise the block is left out of the contract.',
  'Генерирай договор (PDF)': 'Generate contract (PDF)',
  'Генерирай с празни полета': 'Generate with blank fields',
  'Корекция по фактура № {number}': 'Correction to invoice No. {number}',
  'Кредитно известие № {number} е издадено.': 'Credit note No. {number} issued.',
  'Дебитно известие № {number} е издадено.': 'Debit note No. {number} issued.',
  'Корекция на фактура № {number}': 'Correction of invoice No. {number}',
  'Оригиналната фактура остава непроменена. Издава се известие по същата поредица, което я коригира.': 'The original invoice stays unchanged. A note in the same sequence is issued to correct it.',
  'Вид корекция': 'Correction type',
  'Кредитно (намаление)': 'Credit (decrease)',
  'Дебитно (увеличение)': 'Debit (increase)',
  'Редове на корекцията': 'Correction lines',
  'Напр. Отстъпка за наем': 'E.g. Rent discount',
  'Сума (данъчна основа, €)': 'Amount (taxable base, €)',
  '+ Добави ред': '+ Add line',
  'Издай кредитно известие ({amount})': 'Issue credit note ({amount})',
  'Издай дебитно известие ({amount})': 'Issue debit note ({amount})',
  'Обитателят е добавен към имота.': 'Resident added to the property.',
  'Поканата е записана — човекът ще се регистрира със SMS код на този номер.': 'Invitation saved — the person will sign up with an SMS code on this number.',
  'Премахване на обитател': 'Remove resident',
  '{name} ще загуби достъпа до адреса и нередностите на този имот.': '{name} will lose access to the address and issues of this property.',
  'Обитателят е премахнат.': 'Resident removed.',
  'Отмяна на поканата': 'Cancel invitation',
  'Поканата към {name} ({phone}) ще бъде отменена.': 'The invitation to {name} ({phone}) will be cancelled.',
  'Отмени поканата': 'Cancel invitation',
  'Поканата е отменена.': 'Invitation cancelled.',
  'Обитатели': 'Residents',
  'Какво е обитател?': 'What is a resident?',
  'Обитател е човек, който живее в имота, но НЕ е страна по наема — например когато наемът се плаща от фирма или роднина.': 'A resident is a person who lives in the property but is NOT a party to the tenancy — for example when the rent is paid by a company or a relative.',
  '✅ Вижда адреса на имота': '✅ Sees the property address',
  '✅ Подава нередности и ремонти и следи статуса им': '✅ Reports issues and repairs and tracks their status',
  '❌ НЕ вижда наема, задълженията, плащанията, депозита, договора и фактурите': '❌ Does NOT see the rent, dues, payments, deposit, contract or invoices',
  '❌ Не може да плаща или да подписва': '❌ Cannot pay or sign',
  'Известията за нередности получавате вие и наемателят. Достъпът на обитателя спира автоматично при приключване на наемното отношение или когато го премахнете.': 'Issue notifications go to you and the tenant. The resident\'s access ends automatically when the tenancy ends or when you remove them.',
  'Добави обитател': 'Add resident',
  'Няма добавени обитатели.': 'No residents added.',
  'добавен на {date}': 'added on {date}',
  'Поканени, още нерегистрирани': 'Invited, not yet registered',
  'поканен на {date}': 'invited on {date}',
};
